import * as React from "react";

function SvgDinoInterests(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 2104 584"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      {...props}
    >
      <path
        d="M287.218 908.218c28.222-57.809 76.478-108.344 141.743-146.689"
        fill="none"
        stroke="#66a09e"
        strokeWidth={9.58}
        transform="matrix(.44058 -.44514 .44514 .44058 -497.97 -4.02)"
      />
      <path
        d="M37.698 113.793c3.428 1.028 3.288 11.606.862 19.69-2.426 8.083-6.226 10.632-9.653 9.604-3.429-1.03-5.197-5.25-2.77-13.333 2.426-8.084 8.133-16.99 11.561-15.961zM47.8 149.048c2.759 2.328-2.296 12.867-8.35 20.043-6.054 7.176-12.38 6.463-15.14 4.134-2.76-2.328-.915-5.395 5.139-12.571 6.053-7.176 15.59-13.935 18.35-11.606zM42.09 187.126c3.852 1.752 1.74 14.692-2.606 24.248-4.348 9.557-11.633 10.584-15.486 8.831-3.852-1.752-2.822-5.624 1.525-15.181 4.347-9.556 12.714-19.65 16.567-17.898zM47.838 225.409c3.895 1.355 2.27 16.224-1.704 27.648-3.974 11.426-11.182 13.739-15.078 12.384-3.895-1.355-3.012-5.868.961-17.293 3.974-11.425 11.926-24.094 15.821-22.74z"
        fill="#66a09e"
      />
      <path
        d="M.46 234.77c-2.406 2.04 4.988 14.72 12.743 23.866 7.756 9.146 14.202 9.597 16.608 7.557 2.405-2.04-.135-5.802-7.89-14.949-7.756-9.146-19.056-18.513-21.461-16.473zM2.613 181.719c-3.12 1.328-.493 14.528 3.789 24.585 4.282 10.058 10.47 11.894 13.59 10.566 3.12-1.329 2-5.323-2.282-15.38-4.282-10.058-11.976-21.1-15.097-19.771zM9.134 140.857c-2.942.974-1.772 12.506 1.181 21.418 2.953 8.913 8.38 10.837 11.322 9.862 2.942-.975 2.293-4.482-.66-13.394-2.953-8.912-8.901-18.861-11.843-17.886z"
        fill="#66a09e"
      />
      <g>
        <path
          d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
          fill="none"
          stroke="#66a09e"
          strokeWidth={14.79}
          transform="matrix(.01496 -.24877 -.28952 -.01741 2289.169 570.761)"
        />
        <path
          d="M2085.977 435.957c-1.975-1.474-7.73 2.892-11.175 7.508-3.444 4.616-3.282 7.745-1.306 9.22 1.976 1.474 5.022.738 8.466-3.878 3.444-4.616 5.991-11.376 4.015-12.85zM2063.606 442.899c-2.498-.335-5.431 6.147-6.182 11.75-.75 5.604 2.632 8.204 5.13 8.539 2.5.334 3.175-1.722 3.926-7.326.75-5.604-.374-12.629-2.874-12.963zM2046.28 450.733c-2.68-.443-6.31 7.983-7.518 15.274-1.208 7.291 2.266 10.686 4.946 11.13 2.68.444 3.555-2.23 4.763-9.521 1.208-7.291.488-16.439-2.191-16.883zM2029.093 459.894c-2.638-.994-7.869 6.393-10.431 13.193-2.563 6.8.342 10.817 2.981 11.811 2.639.995 4.018-1.408 6.58-8.208 2.563-6.8 3.509-15.802.87-16.796zM2042.86 503.145c-1.596 2.307-10.032-.758-15.957-4.855-5.925-4.097-5.815-9.023-4.22-11.33 1.596-2.307 4.076-1.128 10.002 2.97 5.925 4.096 11.77 10.908 10.174 13.215z"
          fill="#66a09e"
        />
        <path
          d="M2069.332 487.767c-.82 2.616-9.896 2.101-16.873-.088-6.978-2.189-8.4-6.85-7.58-9.466.821-2.616 3.576-2.203 10.554-.014 6.978 2.19 14.72 6.951 13.9 9.568zM2085.817 463.79c.222 2.549-6.425 5.215-12.091 5.71-5.667.494-8.125-3.059-8.348-5.608-.222-2.55 1.875-3.137 7.541-3.632 5.666-.494 12.675.98 12.898 3.53z"
          fill="#66a09e"
        />
      </g>
      <g>
        <path
          d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={15.66}
          transform="matrix(.16587 -.16705 .19442 .19305 1066.919 6.672)"
        />
        <path
          d="M1289.74 65.034c2.28.464 2.825 7.266 1.74 12.597-1.086 5.331-3.393 7.186-5.675 6.721-2.282-.465-3.68-3.074-2.594-8.405 1.086-5.33 4.247-11.378 6.528-10.913zM1298.922 85.164c1.808 1.55-.914 7.694-4.39 11.749-3.477 4.054-7.436 3.307-9.244 1.756-1.808-1.55-.784-3.32 2.692-7.374 3.477-4.054 9.134-7.682 10.942-6.131zM1304.303 102.302c1.998 1.608-1.655 9.468-6.033 14.906-4.377 5.438-8.955 5.126-10.954 3.517-1.998-1.608-.665-3.908 3.713-9.346 4.377-5.438 11.275-10.686 13.274-9.077zM1308.66 120.175c2.361 1.233.446 9.567-2.733 15.65-3.179 6.084-7.837 6.564-10.198 5.33-2.36-1.233-1.535-3.717 1.644-9.8 3.18-6.084 8.927-12.414 11.288-11.18zM1269.525 137.686c-.622 2.575 6.845 6.591 13.46 8.188 6.614 1.597 10.015-1.579 10.637-4.155.622-2.576-1.77-3.582-8.384-5.179-6.615-1.597-15.091-1.43-15.713 1.146z"
          fill="#bcdad1"
        />
        <path
          d="M1263.705 109.357c-1.327 2.224 4.745 8.296 10.678 11.835 5.932 3.54 10.11 1.61 11.438-.615 1.327-2.225-.697-3.906-6.63-7.445-5.932-3.54-14.159-6-15.486-3.775zM1270.229 82.657c-1.936 1.447.367 7.808 3.584 12.112 3.216 4.304 7.266 3.801 9.203 2.354 1.936-1.448 1.03-3.295-2.186-7.598-3.216-4.304-8.665-8.315-10.601-6.868z"
          fill="#bcdad1"
        />
      </g>
      <g>
        <path
          d="M1368.68 4475.63l57.09-41.03 57.09 41.03"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={25.54}
          transform="matrix(0 .69499 -.8625 0 3962.092 -720.623)"
        />
        <path
          d="M1368.68 4475.63l57.09-41.03 57.09 41.03"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={25.54}
          transform="matrix(0 .69499 .8625 0 -3793.424 -720.623)"
        />
        <path
          d="M1368.68 4475.63l57.09-41.03 57.09 41.03"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={25.54}
          transform="matrix(.2766 .63757 -.79124 .34328 3367.363 -2373.439)"
        />
        <path
          d="M1368.68 4442.7l114.18 32.93"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={25.54}
          transform="matrix(.2766 .63757 -.79124 .34328 3318.203 -2352.675)"
        />
        <path
          d="M1368.68 4475.63l57.09-41.03 57.09 41.03"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={25.54}
          transform="matrix(.2766 .63757 .79124 -.34328 -3785.933 729.995)"
        />
        <path
          d="M1368.68 4459.17h114.18"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 3860.56 -405.157)"
        />
        <path
          d="M1368.68 4459.17h114.18"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 3967.872 -405.157)"
        />
        <path
          d="M1368.68 4459.17h114.18"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 4001.7 -404.708)"
        />
        <path
          d="M1368.68 4459.17c.35-31.67 113.87-32.66 114.18 0 .32 33.88-114.56 34.28-114.18 0z"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 3914.182 -405.157)"
        />
        <path
          d="M1368.68 4459.17c.35-31.67 113.87-32.66 114.18 0 .32 33.88-114.56 34.28-114.18 0z"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 4057.399 -404.708)"
        />
        <path
          d="M1368.68 4459.17c.35-31.67 113.87-32.66 114.18 0 .32 33.88-114.56 34.28-114.18 0z"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={26.87}
          transform="matrix(0 .60352 -.8625 0 4131.021 -405.157)"
        />
        <g>
          <path
            d="M1372.48 4471.76s-1.33-12.1 4.03-19.4c8.65-11.8 38.92-20.16 50.34-26.73 11.43 6.57 41.69 14.93 50.34 26.73 5.36 7.3 4.04 19.4 4.04 19.4"
            fill="none"
            stroke="#bfb2af"
            strokeWidth={25.54}
            transform="matrix(-.10285 .68733 -.853 -.12764 4430.867 -293.226)"
          />
          <path
            d="M1372.48 4471.76s-1.33-12.1 4.03-19.4c8.65-11.8 38.92-20.16 50.34-26.73 11.43 6.57 41.69 14.93 50.34 26.73 5.36 7.3 4.04 19.4 4.04 19.4"
            fill="none"
            stroke="#bfb2af"
            strokeWidth={25.54}
            transform="matrix(-.10285 .68733 .853 .12764 -3225.35 -1438.9)"
          />
        </g>
        <g>
          <path
            d="M1369.23 4475.63v-25.65h113.96v25.65"
            fill="none"
            stroke="#bfb2af"
            strokeWidth={25.54}
            transform="matrix(.2593 .6448 .80021 -.3218 -3500.131 1018.163)"
          />
          <path
            d="M1369.23 4475.63v-25.65h113.96v25.65"
            fill="none"
            stroke="#bfb2af"
            strokeWidth={25.54}
            transform="matrix(.2593 .6448 -.80021 .3218 3699.2 -1876.95)"
          />
        </g>
        <g>
          <path
            d="M703.214 172.875l11.723-4.83c2.456-1.011 4.426-1.3 5.799-.821 1.373.479 2.575 1.812 3.449 3.933.874 2.122.96 3.915.323 5.222-.591 1.418-2.194 2.601-4.65 3.613l-36.955 15.224c-2.456 1.012-4.426 1.302-5.845.71-1.373-.479-2.575-1.812-3.449-3.933-.874-2.121-.96-3.914-.322-5.221.636-1.307 2.127-2.444 4.695-3.502l11.723-4.83-19.502-47.337-6.029 2.484c-2.456 1.012-4.427 1.301-5.957.756-1.373-.48-2.575-1.812-3.449-3.933-.874-2.122-.96-3.915-.323-5.222.703-1.465 2.305-2.647 4.762-3.659l16.3-6.715c1.005-.414 1.878-.513 2.574-.408.742.217 1.307.637 1.63 1.418l23.503 57.051zM744.53 144.1c2.549 3.652 5.689 5.884 9.196 6.79 3.508.906 7.606.393 12.072-1.447 4.466-1.84 8.471-4.796 12.063-8.757 3.435-4.027 5.654-6.247 6.547-6.615 1.34-.552 2.687-.454 3.836.117 1.307.637 2.306 1.793 2.95 3.356 1.425 3.461.053 7.422-3.959 11.948-4.012 4.526-9.758 8.33-17.238 11.411-8.82 3.634-16.978 4.121-24.472 1.463-7.494-2.659-12.907-7.873-16.127-15.688-3.174-7.704-3.004-15.217.397-22.495 3.447-7.166 9.58-12.566 18.4-16.2 7.815-3.22 15.368-3.589 22.39-1.127 7.067 2.573 11.98 7.21 14.74 13.908.874 2.121 1.026 3.757.231 4.998-.637 1.307-2.62 2.516-5.858 3.85l-35.168 14.489zm25.867-20.581c-1.938-3.12-4.716-5.11-8.02-5.838-3.238-.886-6.956-.399-11.087 1.303-4.019 1.656-6.777 3.837-8.497 6.635-1.655 2.64-2.337 6.056-1.759 9.997l29.363-12.097zM812.137 86.603l16.636-6.853c2.567-1.058 4.426-1.301 5.91-.868 1.42.59 2.575 1.812 3.45 3.933.873 2.122.959 3.915.322 5.222-.702 1.465-2.305 2.647-4.761 3.659l-16.635 6.853 5.75 13.956c1.61 3.908 3.271 6.357 5.097 7.302 1.826.946 4.27.854 7.284-.388 2.791-1.15 5.818-3.312 9.036-6.596 3.106-3.239 5.352-5.078 6.692-5.63 1.451-.598 3.02-.592 4.532.223 1.576.656 2.732 1.877 3.422 3.552 1.15 2.791-.36 6.417-4.418 10.831-4.216 4.349-9.404 7.923-15.88 10.59-3.684 1.518-7.263 2.34-10.468 2.485-3.317.191-6.148-.34-8.493-1.594-1.826-.946-3.455-2.364-4.73-4.19-1.385-1.78-3.034-5.148-4.966-9.838l-6.256-15.183-5.135 2.115c-2.457 1.012-4.427 1.302-5.846.71-1.372-.478-2.575-1.811-3.448-3.933-.874-2.121-.96-3.914-.323-5.221s2.239-2.49 4.695-3.502l5.136-2.115-5.244-12.728c-1.057-2.568-1.19-4.473-.598-5.891.545-1.53 2.147-2.713 4.491-3.68 2.457-1.011 4.315-1.254 5.78-.552 1.419.591 2.667 2.036 3.725 4.604l5.243 12.727z"
            fill="#bfb2af"
            fillRule="nonzero"
          />
        </g>
        <g>
          <path
            d="M329.889 227.367c.87-1.393 1.85-2.256 2.97-2.708 1.151-.568 2.528-.576 4.045-.172 2.1.56 3.345 1.516 3.936 3.049.475 1.5.382 3.725-.426 6.759l-2.487 9.334c-.622 2.334-1.524 3.843-2.768 4.76-1.214.802-2.886.981-4.87.453-1.4-.373-2.473-1.034-3.25-1.866-.748-.949-1.487-2.395-2.04-4.542-.833-2.971-2.319-5.367-4.427-7.303-2.108-1.936-4.986-3.328-8.603-4.292-4.434-1.181-8.455-.628-12.002 1.426-3.694 2.14-6.089 5.5-7.301 10.051-1.275 4.784-.753 8.922 1.387 12.616 2.14 3.694 5.733 6.151 10.634 7.457 4.434 1.181 9.178 1.196 14.296-.19 5.087-1.269 8.112-1.837 9.162-1.557 1.4.373 2.412 1.267 3.065 2.566.654 1.299.748 2.823.313 4.457-.964 3.617-4.487 6.052-10.717 7.391-6.114 1.37-12.904 1.06-20.371-.929-9.218-2.456-16.001-7.013-20.35-13.67-4.35-6.657-5.495-14.085-3.319-22.252 2.114-7.934 6.687-13.839 13.803-17.566 7.116-3.727 15.065-4.483 23.7-2.183a35.968 35.968 0 018.237 3.32c2.583 1.563 4.986 3.328 7.383 5.59zM380.942 249.217c-4.434-1.181-8.572-.66-12.118 1.395-3.694 2.14-6.09 5.5-7.302 10.05-1.212 4.551-.807 8.658 1.302 12.469 2.023 3.663 5.352 6.174 9.786 7.356 4.434 1.181 8.455.628 12.15-1.512 3.725-2.256 6.12-5.617 7.332-10.167 1.212-4.55.807-8.657-1.333-12.351-2.054-3.547-5.383-6.059-9.817-7.24zm3.202-12.018c9.218 2.456 16.001 7.013 20.35 13.67 4.319 6.774 5.464 14.202 3.319 22.253-2.177 8.167-6.866 14.04-13.95 17.65-7.086 3.611-15.237 4.189-24.455 1.733-9.217-2.456-16-7.013-20.35-13.67-4.35-6.657-5.494-14.085-3.318-22.253 2.145-8.05 6.834-13.924 13.95-17.651 7.085-3.61 15.237-4.188 24.454-1.732zM467.073 303.532l.7.186c2.1.56 3.578 1.579 4.349 2.908.801 1.214.95 3.003.39 5.103-.591 2.217-1.61 3.695-2.909 4.348-1.33.77-3.32.74-5.888.056l-14-3.73c-2.568-.685-4.31-1.649-5.08-2.979-.919-1.244-1.067-3.033-.476-5.25.56-2.1 1.578-3.578 2.877-4.232 1.33-.77 3.119-.918 5.336-.327l.7.186 4.383-16.451c1.213-4.55 1.383-8.004.597-10.213-.638-2.295-2.607-3.819-5.523-4.596-3.15-.84-6.029-.357-8.634 1.449-2.574 1.688-4.433 4.442-5.458 8.292l-4.384 16.452.7.186c2.217.59 3.578 1.578 4.465 2.94.802 1.213.833 2.97.274 5.07-.591 2.218-1.61 3.696-2.908 4.35-1.33.77-3.322.739-5.888.055l-14.119-3.762c-2.566-.684-4.192-1.617-5.08-2.978-.8-1.213-.949-3.002-.358-5.219.56-2.1 1.578-3.578 2.877-4.232 1.33-.77 3.119-.918 5.219-.359l.7.187 7.337-27.536-.934-.249c-2.1-.56-3.461-1.547-4.231-2.877-.77-1.33-.95-3.002-.421-4.985.59-2.217 1.609-3.695 2.908-4.349 1.446-.74 3.437-.709 6.004-.025l9.685 2.58c1.05.28 1.804.732 2.294 1.237.46.622.537 1.268.32 2.084l-1.182 4.434c2.497-2.334 5.242-3.727 8.299-4.412 3.173-.654 6.393-.545 10.01.418 6.068 1.617 10.12 4.696 12.19 9.122 1.923 4.51 1.947 10.515-.074 18.1l-5.067 19.018zM494.978 323.588c-1.268.537-2.357.872-3.5.942-1.144.07-2.256.024-3.423-.287-1.633-.435-2.676-1.213-3.041-2.185-.452-1.12-.366-2.847.255-5.18l2.021-7.585c.653-2.45 1.617-4.192 2.714-5.025 1.096-.832 2.62-.926 4.72-.366 2.218.59 3.805 2.138 4.614 4.728.506 1.384.989 2.387 1.416 3.126 1.401 2.248 3.19 3.974 5.54 5.475 2.201 1.586 4.908 2.682 8.058 3.522 2.684.715 5.025.839 6.939.224 1.944-.732 3.103-1.797 3.569-3.548.808-3.033-3.035-6.431-11.475-9.93-1.804-.73-3.259-1.368-4.395-1.796-6.402-2.705-10.836-5.761-13.271-9.284-2.552-3.554-3.222-7.606-2.01-12.157 1.43-5.367 4.502-8.922 9.13-10.813 4.628-1.891 10.632-1.916 17.75-.02 2.45.653 4.955 1.57 7.428 2.605a74.923 74.923 0 017.554 4.012c1.065-.716 2.068-1.199 3.126-1.417.941-.249 2.053-.202 3.104.077 1.633.436 2.676 1.213 3.212 2.481.569 1.151.545 2.644.017 4.628l-1.865 7c-.436 1.634-1.128 2.824-2.31 3.51-1.034.598-2.325.754-3.842.35s-3.827-2.52-6.846-6.198c-3.135-3.71-6.496-6.104-10.346-7.13-2.917-.777-5.375-.933-7.289-.318-1.882.498-3.04 1.564-3.507 3.315-.715 2.683 2.202 5.335 8.838 8.102 1.921.762 3.376 1.4 4.511 1.827 8.293 3.584 13.63 7.006 16.243 10.326 2.498 3.29 3.136 7.459 1.83 12.36-1.523 5.717-4.804 9.59-9.96 11.59-5.04 2.032-11.395 1.963-19.213-.12-3.033-.808-5.888-1.818-8.595-2.915-2.707-1.096-5.352-2.425-7.701-3.926zM589.05 296.544l17.385 4.632c2.683.715 4.31 1.648 5.227 2.893.77 1.33.95 3.002.36 5.219-.592 2.217-1.61 3.695-2.91 4.348-1.446.74-3.437.709-6.004.025l-17.385-4.632-3.886 14.584c-1.088 4.084-1.25 7.04-.371 8.899.879 1.859 2.878 3.266 6.028 4.105 2.917.778 6.635.893 11.185.231 4.434-.693 7.335-.794 8.735-.421 1.517.404 2.762 1.36 3.47 2.923.856 1.478 1.035 3.15.569 4.9-.778 2.917-4.176 4.886-10.08 5.937-5.989.904-12.281.602-19.048-1.201-3.85-1.026-7.196-2.542-9.833-4.37-2.754-1.858-4.683-3.997-5.788-6.415-.88-1.86-1.315-3.975-1.223-6.2-.023-2.255.707-5.934 2.013-10.835l4.228-15.868-5.367-1.43c-2.567-.684-4.31-1.648-5.08-2.978-.802-1.213-.95-3.002-.359-5.219.59-2.217 1.61-3.695 2.908-4.349 1.299-.653 3.29-.622 5.857.061l5.367 1.43 3.544-13.3c.715-2.684 1.765-4.28 3.095-5.05 1.361-.886 3.352-.856 5.802-.203 2.567.684 4.193 1.617 4.932 3.064.77 1.33.888 3.235.173 5.919l-3.544 13.301z"
            fill="#bfb2af"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g>
        <path
          d="M1472.01 4457.13c-25.34 6.12-95.12 9.81-103.33 2.04 18.92-6.87 49.38-8 103.33-2.04z"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={20.36}
          transform="matrix(.40812 .77006 -.95566 .50649 5494.61 -3023.445)"
        />
        <path
          d="M1484.73 4454.15c7.19-5.99 23.67-.06 36.75-4.15-6.68 17.97-25.81 22.79-36.08 13.13-1.9-1.79-2.07-7.81-.67-8.98z"
          fill="none"
          stroke="#bfb2af"
          strokeWidth={20.36}
          transform="matrix(.40812 .77006 -.95566 .50649 5504.426 -3011.241)"
        />
        <path
          d="M1487.89 4467.84h-91.39l-.27-24.21h91.39l28.36 11.58-28.09 12.63z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={12.68}
          transform="matrix(-.62223 .89236 -.63906 -.4456 5221.863 970.951)"
        />
        <path
          d="M1407.1 4467.84h-10.6l-.27-24.21h10.6l.27 24.21z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={13.85}
          transform="matrix(-.54101 .77588 -.63906 -.4456 5125.286 1109.455)"
        />
        <path
          d="M1425.03 4530.38h-54.31l-.28-86.75h54.32l.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={13.94}
          transform="matrix(-.21324 -.90356 .76622 -.18083 -1601.708 2160.044)"
        />
        <path
          d="M1376.7 4530.38l-5.96 8.29-.3-103.15 5.99 8.11.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={13.89}
          transform="matrix(-.22646 -.95956 .7016 -.16558 -1309.56 2100.953)"
        />
        <path
          d="M1425.03 4530.38h-54.31l-.28-86.75h54.32l.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={18.2}
          transform="matrix(.4523 -.7039 .3458 .2222 -124.863 264.573)"
        />
        <path
          d="M1376.7 4530.38l-5.96 8.29-.3-103.15 5.99 8.11.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={17.59}
          transform="matrix(.48033 -.74752 .31664 .20346 1.32 355.93)"
        />
        <path
          d="M1425.03 4530.38h-54.31l-.28-86.75h54.32l.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={16.58}
          transform="matrix(-.07505 -.49358 .88352 -.13434 -1874.3 1788.094)"
        />
        <path
          d="M1376.7 4530.38l-5.96 8.29-.3-103.15 5.99 8.11.27 86.75z"
          fill="#bfb2af"
          stroke="#bfb2af"
          strokeOpacity={0.99}
          strokeWidth={16.71}
          transform="matrix(-.09048 -.5951 .80901 -.123 -1525.168 1834.575)"
        />
        <g>
          <path
            d="M1425.03 4530.38h-54.31l-.28-86.75h54.32l.27 86.75z"
            fill="#bfb2af"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={20.28}
            transform="matrix(.1295 -.68557 .45398 .08575 -898.53 733.373)"
          />
          <path
            d="M1376.7 4530.38l-5.96 8.29-.3-103.15 5.99 8.11.27 86.75z"
            fill="#bfb2af"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={19.73}
            transform="matrix(.13902 -.73598 .4157 .07852 -730.02 783.195)"
          />
        </g>
        <g>
          <path
            d="M265.24 970.652c25.212-82.597 81.542-156.433 163.721-209.123"
            fill="none"
            stroke="#66a09e"
            strokeWidth={10.6}
            transform="matrix(-.61868 -.45136 -.43798 .60034 2221.711 -4.795)"
          />
          <path
            d="M1610.603 227.425c-4.674 1.759-3.829 14.64.02 24.143 3.85 9.503 9.257 12.054 13.93 10.295 4.675-1.759 6.858-7.166 3.008-16.67-3.85-9.502-12.284-19.527-16.958-17.768zM1599.64 277.118c-3.158 4.925 5.959 16.335 15.65 22.483 9.694 6.15 17.972 1.239 21.13-3.688 3.159-4.926.008-8.015-9.685-14.163-9.692-6.149-23.937-9.559-27.095-4.632zM1605.626 318.836c-3.775 4.7 5.366 17.934 15.494 25.748 10.128 7.815 19.476 3.864 23.252-.837 3.775-4.7.557-8.38-9.571-16.195-10.128-7.815-25.4-13.417-29.175-8.716zM1607.988 363.657c-5.56 4.625 1.574 21.742 11.24 32.83 9.668 11.089 21.463 8.48 27.025 3.855 5.562-4.626 2.799-9.525-6.869-20.614-9.667-11.088-25.833-20.696-31.396-16.07z"
            fill="#66a09e"
          />
          <path
            d="M1683.641 369.467c3.492 5.027-5.975 17.75-16.184 24.921-10.209 7.172-19.172 2.497-22.665-2.53-3.493-5.029-.2-8.518 10.01-15.689 10.208-7.17 25.347-11.73 28.84-6.702zM1678.34 308.476c4.246 3.872-2.637 18.837-11.21 28.646-8.572 9.81-18.025 7.823-22.272 3.951-4.247-3.872-1.689-8.172 6.884-17.982 8.572-9.809 22.351-18.487 26.598-14.615zM1651.858 259.287c4.753 2.016 3.64 16.215-.486 26.639s-12.649 11.39-17.403 9.373c-4.754-2.017-3.948-6.256.178-16.68s12.957-21.35 17.711-19.332z"
            fill="#66a09e"
          />
        </g>
        <g>
          <path
            d="M265.491 969.548c18.336-84.087 74.222-157.966 163.47-208.019"
            fill="none"
            stroke="#bcdad1"
            strokeWidth={14.86}
            transform="matrix(-.09432 -.53006 -.53006 .09432 2174.432 457.083)"
          />
          <path
            d="M1738.054 278.338c-3.527-1.14-9.233 6.725-11.59 14.02-2.357 7.294-.48 11.273 3.047 12.413 3.528 1.14 7.38-.988 9.737-8.282 2.357-7.295 2.334-17.011-1.194-18.151zM1710.617 296.408c-3.104.724-3.412 10.785-1.577 18.644 1.835 7.86 7.077 9.754 10.18 9.03 3.105-.725 2.902-3.797 1.067-11.656-1.835-7.86-6.566-16.743-9.67-16.018zM1693.494 328.407c-3.656.369-5.533 11.49-4.628 20.47.904 8.979 6.606 11.818 10.262 11.45 3.656-.369 3.89-3.806 2.985-12.786-.905-8.98-4.963-19.502-8.62-19.134zM1674.381 348.035c-3.42-.322-7.373 11.892-8.35 22.244-.976 10.353 3.671 14.722 7.092 15.045 3.42.322 4.325-3.523 5.302-13.876.976-10.352-.623-23.09-4.044-23.413z"
            fill="#bcdad1"
          />
          <path
            d="M1710.658 392.207c-.327 3.756-12.969 5.73-23.238 4.835-10.27-.893-13.656-6.738-13.329-10.494.327-3.757 4.243-4.011 14.513-3.118 10.27.894 22.38 5.02 22.054 8.777zM1684.88 409.746c-.17 3.775-13.48 6.247-24.409 5.753-10.93-.493-14.792-6.216-14.622-9.992.17-3.777 4.31-4.185 15.24-3.691 10.928.493 23.961 4.153 23.79 7.93z"
            fill="#bcdad1"
          />
          <path
            d="M1643.556 364.76c-4.248-.064-7.914 14.23-8.095 26.136-.18 11.905 5.98 16.48 10.228 16.544 4.248.065 4.984-4.405 5.165-16.31.18-11.906-3.05-26.305-7.298-26.37zM1732.268 355.488c.615 3.581-10.046 8.407-19.307 9.999-9.26 1.591-13.648-3.062-14.264-6.645-.616-3.582 2.773-4.744 12.034-6.335 9.26-1.592 20.921-.601 21.537 2.98zM1749.74 318.449c.938 2.993-7.583 8.331-15.284 10.743-7.702 2.413-11.976-1.07-12.914-4.064-.937-2.994 1.814-4.373 9.516-6.785 7.701-2.412 17.745-2.888 18.682.106z"
            fill="#bcdad1"
          />
        </g>
        <g>
          <path
            d="M1784.442 472.506l-179.39-85.095-100.928 41.274 179.39 85.095 100.928-41.274z"
            fill="#bfb2af"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={20.000726399999998}
          />
          <path
            d="M1492.35 453.508l190.946 90.576 93.778-38.018"
            fill="none"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={20.000726399999998}
          />
        </g>
        <g>
          <path
            d="M1662.567 131.962l236.586-49.633 107.715 77.604-236.586 49.633-107.715-77.604z"
            fill="#bfb2af"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={19.9948518}
          />
          <path
            d="M3060.66 4608.95h-219.19l-79.37 99.49h219.2l79.36-99.49z"
            fill="#f0f0f0"
            stroke="#f0f0f0"
            strokeOpacity={0.99}
            strokeWidth={13.71}
            transform="rotate(168.151 2092.49 -1835.722) scale(.94542 -.79887)"
          />
          <path
            d="M1372.36 4657.13c-14.42-37.26-26.83-120.35-2.71-138.42 7.92-5.92 16.28 82.1 9.6 86.4-25.33 16.28-66.67-47.45-57.12-82.44 6.6-24.14 36.79-45.19 55.18-67.79"
            fill="none"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={12.85}
            transform="matrix(-.14185 -.87728 .64144 -.10371 -903.206 1807.331)"
          />
          <path
            d="M1504.14 4466.52l-133.42 1.32-.28-24.21 133.43-1.33 12.99 12.56-12.72 11.66z"
            fill="#bfb2af"
            stroke="#bfb2af"
            strokeOpacity={0.99}
            strokeWidth={17.68}
            transform="matrix(-.53493 .70964 -.29002 -.21862 4006.892 10.01)"
          />
        </g>
      </g>
      <g>
        <path
          d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
          fill="none"
          stroke="#bcdad1"
          strokeWidth={12.17}
          transform="matrix(.14976 -.63982 .63982 .14976 105.192 403.53)"
        />
        <path
          d="M646.736 204.432c4.162-1.101 11.212 11.875 14.258 23.383 3.047 11.51.943 17.223-3.219 18.324-4.162 1.102-8.817-2.822-11.863-14.331-3.046-11.51-3.338-26.274.824-27.376zM679.141 235.897c4.353.66 5.842 14.694 4.144 25.893-1.698 11.2-8.72 14.448-13.075 13.788-4.353-.66-4.399-4.979-2.701-16.18 1.698-11.199 7.278-24.16 11.632-23.5zM692.743 271.352c4.707-.584 10.443 14.38 12.032 27.189 1.589 12.81-4.716 18.486-9.423 19.07-4.708.584-6.046-4.145-7.635-16.954-1.588-12.81.318-28.721 5.026-29.305zM722.948 308.403c4.81-1.054 11.988 13.032 14.703 25.429 2.716 12.398-3.317 18.608-8.128 19.662-4.81 1.053-6.589-3.446-9.304-15.844-2.715-12.397-2.082-28.194 2.73-29.247z"
          fill="#bcdad1"
        />
        <path
          d="M681.047 346.334c-1.528 4.654 11.638 13.163 23.592 17.087 11.954 3.924 18.694-1.425 20.222-6.08 1.528-4.655-2.73-6.864-14.685-10.788-11.954-3.924-27.6-4.874-29.129-.22zM723.9 389.805c.463 4.3 15.915 6.168 28.424 4.82 12.51-1.35 16.537-8.164 16.073-12.465-.463-4.302-5.244-4.47-17.753-3.122-12.51 1.349-27.208 6.466-26.745 10.767z"
          fill="#bcdad1"
        />
        <path
          d="M749.754 339.945c4.366-2.758 16.008 7.823 22.727 18.46 6.72 10.638 2.845 18.685-1.522 21.443-4.366 2.758-7.581-.811-14.3-11.45-6.719-10.636-11.271-25.695-6.905-28.453zM651.416 297.335c-2.775 3.903 7.518 15.99 17.928 23.39s18.397 4.462 21.172.558c2.774-3.903-.707-7.301-11.117-14.702-10.41-7.4-25.209-13.149-27.983-9.246zM630.17 250.99c-2.881 3.416 10.207 19.199 23.008 29.992 12.802 10.794 21.844 9.844 24.726 6.427 2.881-3.418-1.483-8.017-14.285-18.81-12.801-10.794-30.568-21.027-33.45-17.61z"
          fill="#bcdad1"
        />
        <g>
          <path
            d="M265.24 970.652c18.833-83.804 75.869-157.506 163.721-209.123"
            fill="none"
            stroke="#66a09e"
            strokeWidth={9.58}
            transform="matrix(-.54227 -.31337 .31337 -.54228 616.415 953.254)"
          />
          <path
            d="M594.614 405.215c.126-3.576 10.394-6.122 18.828-5.824 8.435.299 11.864 3.328 11.737 6.904-.126 3.578-3.76 6.357-12.195 6.06-8.434-.299-18.497-3.562-18.37-7.14zM626.158 386.509c1.552-3.26 13.028-1.04 21.504 2.996 8.477 4.038 9.39 10.337 7.837 13.598-1.553 3.26-4.987 2.253-13.464-1.785-8.476-4.037-17.43-11.55-15.877-14.81zM664.44 382.38c.718-4.17 13.77-5.407 24.117-3.624 10.346 1.783 13.186 8.57 12.467 12.741-.719 4.171-4.726 4.156-15.072 2.373-10.346-1.783-22.232-7.318-21.513-11.49zM700.015 367.117c.324-4.112 15.12-6.307 27.178-5.359 12.06.948 16.124 7.335 15.8 11.447-.323 4.112-4.912 4.401-16.972 3.453-12.059-.948-26.33-5.43-26.006-9.541z"
            fill="#66a09e"
          />
          <path
            d="M721.08 410.576c2.582 1.81 12.973-8.556 19.855-18.376 6.883-9.82 5.685-16.17 3.102-17.981-2.583-1.81-5.579 1.6-12.461 11.422-6.882 9.82-13.08 23.125-10.496 24.935zM669.214 421.938c2.076 2.682 14.179-3.204 22.822-9.896 8.644-6.69 8.853-13.142 6.777-15.824-2.076-2.682-5.656-.585-14.3 6.106-8.643 6.691-17.375 16.932-15.299 19.614zM628.034 425.988c1.688 2.599 12.547-1.456 20.42-6.572 7.873-5.115 8.359-10.852 6.67-13.451-1.69-2.6-4.917-1.083-12.79 4.033-7.873 5.115-15.99 13.39-14.3 15.99z"
            fill="#66a09e"
          />
        </g>
      </g>
      <g transform="matrix(-1.47662 0 0 1.47662 1824.815 -382.547)">
        <g transform="translate(-76.315 -123.566) scale(1.17736)">
          <path
            d="M370.48 660.885c7.682-59.827 16.061-134.051 2.345-127.469-31.011 14.881-66.726 69.449-84.57 127.469h82.225z"
            fill="#fe9e9b"
          />
          <clipPath id="dino_interests_svg___clip1">
            <path d="M370.48 660.885c7.682-59.827 16.061-134.051 2.345-127.469-31.011 14.881-66.726 69.449-84.57 127.469h82.225z" />
          </clipPath>
          <g clipPath="url(#dino_interests_svg___clip1)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(-.48761 .36598 .3123 .4161 443.489 44.262)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(-.19964 .14984 .16154 .21523 344.773 379.246)"
            />
          </g>
        </g>
        <g transform="matrix(-1.17736 0 0 1.17736 1164.08 -123.566)">
          <path
            d="M288.255 660.885c17.844-58.02 53.559-112.588 84.57-127.469 13.716-6.582 5.337 67.642-2.345 127.469h-82.225z"
            fill="#fe9e9b"
          />
          <clipPath id="dino_interests_svg___clip2">
            <path d="M288.255 660.885c17.844-58.02 53.559-112.588 84.57-127.469 13.716-6.582 5.337 67.642-2.345 127.469h-82.225z" />
          </clipPath>
          <g clipPath="url(#dino_interests_svg___clip2)">
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(.24234 .06571 -.07491 .27626 229.453 356.586)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fe8b88"
              transform="matrix(.14998 .04067 -.04444 .16388 265.317 417.922)"
            />
          </g>
        </g>
        <path
          d="M454.922 405.876c-4.82-17.995 20.763-48.398 29.128-53.652 8.334-5.234 25.92 13.185 21.066 22.128-4.855 8.941-48.455 36.44-50.194 31.524z"
          fill="#fd6b67"
        />
        <path
          d="M480.736 391.034c-1.97-7.747 27.087-62.892 52.264-64.544 11.065-.726 20.53 35.72 11.819 46.478-8.71 10.756-62.113 25.813-64.083 18.066z"
          fill="#fd6b67"
        />
        <path
          d="M756.79 654.534c-1.168-42.017-4.871-77.3-7.495-92.009-18.486-103.632-100.715-192.791-205.981-193.322-105.266.531-187.495 89.69-205.982 193.322-2.626 14.723-5.698 49.972-6.586 92.009H756.79z"
          fill="#feb4b2"
        />
        <clipPath id="dino_interests_svg___clip3">
          <path d="M756.79 654.534c-1.168-42.017-4.871-77.3-7.495-92.009-18.486-103.632-100.715-192.791-205.981-193.322-105.266.531-187.495 89.69-205.982 193.322-2.626 14.723-5.698 49.972-6.586 92.009H756.79z" />
        </clipPath>
        <g clipPath="url(#dino_interests_svg___clip3)">
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fea5a3"
            transform="matrix(.84711 .04306 -.0492 .96801 82.8 -308.915)"
          />
          <ellipse
            cx={716.185}
            cy={713.203}
            rx={33.711}
            ry={33.625}
            fill="#fea5a3"
            transform="matrix(.25025 -.12328 .13025 .2644 398.112 508.517)"
          />
          <ellipse
            cx={522.817}
            cy={430.672}
            rx={20.488}
            ry={28.446}
            fill="#fea5a3"
            transform="rotate(-37.754 520.875 443.7)"
          />
          <ellipse
            cx={451.534}
            cy={438.87}
            rx={15.874}
            ry={8.198}
            fill="#fea5a3"
            transform="rotate(-22.303 451.535 438.869)"
          />
        </g>
        <path
          d="M519.05 370.398c-6.132 14.619 25.332 59.94 36.567 53.7 11.234-6.238 43.898-65.617 23.883-89.697-12-14.436-52.788 17.732-60.45 35.997z"
          fill="#fd6b67"
        />
        <path d="M391.086 523.5c-8.22 1.203-17.462-5.742-17.7-4.637-1.409 6.52 5.526 17.512 11.613 22.39l6.087-17.753zM695.888 523.5c8.22 1.203 17.462-5.742 17.7-4.637 1.409 6.52-5.526 17.512-11.613 22.39l-6.087-17.753z" />
        <circle
          cx={427.545}
          cy={531.3}
          r={27.325}
          transform="translate(-37.066 -15.274) scale(1.04746)"
        />
        <circle
          cx={427.545}
          cy={531.3}
          r={27.325}
          transform="translate(229.051 -15.274) scale(1.04746)"
        />
        <circle
          cx={437.886}
          cy={527.93}
          r={10.341}
          fill="#fff"
          transform="translate(-40.362 -15.851) scale(1.04746)"
        />
        <circle
          cx={437.886}
          cy={527.93}
          r={10.341}
          fill="#fff"
          transform="translate(225.755 -15.851) scale(1.04746)"
        />
        <g>
          <path
            d="M639.106 557.436c-8.853 18.34-20.05 25.08-32.136 26.5-10.038 1.18-20.806-1.43-31.566-4.39-10.07-2.77-20.15-5.87-29.65-5.82-9.878-.04-20.142 3.48-30.507 6.53-10.92 3.22-21.94 5.97-32.649 4.34-11.843-1.8-23.434-8.81-34.051-26.64a1.91 1.91 0 01.638-2.62 1.903 1.903 0 012.62.63c10.063 16.07 20.605 22.49 31.465 23.92 10.038 1.32 20.26-1.57 30.432-4.72 10.852-3.37 21.653-7.04 32.035-7.12 9.996.02 20.604 3.18 31.154 6.23 10.08 2.91 20.108 5.71 29.575 4.84 10.91-1.02 20.931-7.04 29.373-23.32a1.831 1.831 0 012.452-.81c.899.45 1.269 1.55.815 2.45z"
            fill="#b64646"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgDinoInterests;
